import { Box } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import Header from "../Header";
import MSSPAdminWarningBanner from "../MSSPAdminWarningBanner";

const AppPage = ({
  title = null,
  title2 = null,
  subtitle = null,
  children,
}) => {
  const colors = useColors();

  return (
    <Box
      ml="20px"
      mr="20px"
      mt="20px"
      sx={{
        backgroundColor: colors.common_white,
      }}
    >
      <Header title={title} title2={title2} subtitle={subtitle}></Header>
      <MSSPAdminWarningBanner />
      {children}
    </Box>
  );
};

export default AppPage;
